import Swiper, { Pagination } from 'swiper';

Swiper.use([Pagination]);

function initCarousels() {
    const elems = document.querySelectorAll('.swiper');

    if (elems.length > 0 && window.innerWidth < 479) {
        console.log('Projects Slideshow initialised');
        elems.forEach(elem => {

            const swiper = new Swiper(elem, {
                speed: 400,
                loop: false,
                slidesPerView: 1,
                centeredSlides: false,
                initialSlide: 0,
                slidesPerView: 1
            });
            $('.swiper-prev').on('click', function () {
                swiper.slidePrev();
            });

            $('.swiper-next').on('click', function () {
                    swiper.slideNext();
            });
        });
    }
}

initCarousels();


